import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import type { MayBe } from 'modules/global/typing/common/common';

import * as types from '../actionTypes';

export default loadingArraySlice(types.REDIRECT_TO_CUSTOM_TEMPLATE_LINK_REQUEST, {
  global: {
    selectId: (payload: MayBe<{ templateId?: string } | string>) =>
      (typeof payload === 'string' ? payload : payload?.templateId),
  },
});
